import { gql } from '@apollo/client';
export const PROGRAM_RECORD_LINE_LIST = gql`
  fragment ProgramRecordLine on PortalExpedientLineDTO {
    programRecordId
    subjectCode
    subjectCodeOfficial
    subjectName
    subjectCredits
    course
    trainingPeriodName
    enrollmentValidated
    qualification
    qualificationLabel
    examCallTypeLevel1
    examCallTypeLevel1Label
    examDate
  }
`;
export const PROGRAM_RECORD_LIST = gql`
  ${PROGRAM_RECORD_LINE_LIST}
  fragment ProgramRecordList on PortalExpedientDTO {
    ID
    trainingProgramName
    state
    stateLabel
    programRecordLineList {
      ...ProgramRecordLine
    }
  }
`;
export const STUDENT_ACADEMIC_RECORDS = gql`
  ${PROGRAM_RECORD_LIST}
  fragment StudentAcademicRecords on StudentAcademicRecordsDTO {
    programRecordList {
      ...ProgramRecordList
    }
  }
`;
export const PORTAL_EXPEDIENT_PDF_DTO = gql`
  fragment PortalExpedientPDFDTO on PortalExpedientPDFDTO {
    ID
  }
`;